<template>
  <el-select
    filterable
    v-model="selectedState"
    @input="$emit('input', selectedState)"
    @change="$emit('change', selectedState)"
  >
    <el-option
      v-for="state in states"
      :key="state.id"
      :label="state.name"
      :value="state.id"
    ></el-option>
  </el-select>
</template>

<script>
import routingService from '@/api/routingService';

export default {
  name: 'StateSelect',
  props: ['value', 'includeOptionAll'],
  data() {
    return {
      selectedState: null,
      states: []
    };
  },
  mounted() {
    if (this.includeOptionAll) {
      this.states = [
        {
          id: null,
          name: this.$t('common.all')
        }
      ];
    }

    routingService.getStates().then((response) => {
      this.states = this.states.concat(
        response.data.map(state => ({
          id: state.id,
          name: state.name.concat(' - ').concat(state.code)
        }))
      );
    });
  }
};
</script>
